module.exports = __webpack_public_path__ + "img/receipt-printer.3406f72d.webp";